import {
  isUnpairedRdItemMasterLetter,
  matchRdStockAndItemMasterLocations,
  normalizeRdBranchLetter,
  type RdLocationMatch,
  type RdLocationUnmatchedReason,
} from '@erp/rpc';

function unmatched(
  stockLetter: string,
  itemMasterLetter: string,
  reason: RdLocationUnmatchedReason,
): Extract<RdLocationMatch, { status: 'unmatched' }> {
  return { status: 'unmatched', stockLetter, itemMasterLetter, reason };
}

/**
 * STOCKS_V has both letters. Do not auto-fill a missing partner the way
 * STOCK_V does — a blank side is unmatched, not a Vera pair.
 * Letter equality is never a match (GEN-2668).
 */
export function classifySupersededLocations(args: {
  stockLetter: string;
  itemMasterLetter: string;
}): RdLocationMatch {
  const stockLetter = normalizeRdBranchLetter(args.stockLetter);
  const itemMasterLetter = normalizeRdBranchLetter(args.itemMasterLetter);
  if (stockLetter !== '' && itemMasterLetter !== '') {
    return (
      matchRdStockAndItemMasterLocations({
        stockLetter,
        itemMasterLetter,
      }) ??
      unmatched(stockLetter, itemMasterLetter, 'stockItemLocationMismatch')
    );
  }
  if (stockLetter === '' && itemMasterLetter === '') {
    return unmatched('', '', 'unmappedStockLocation');
  }
  if (stockLetter === '') {
    return unmatched(
      '',
      itemMasterLetter,
      isUnpairedRdItemMasterLetter(itemMasterLetter)
        ? 'unpairedItemMasterLocation'
        : 'unmappedStockLocation',
    );
  }
  return unmatched(stockLetter, '', 'unmappedItemMasterLocation');
}
